import type { Handler } from './handler';
import type {
  ApiFetchGiratudoStatusPort,
  RaffleStatus,
} from './ports/api-fetch-giratudo-status.port';
import { tryCatch } from '~/utils/apostatudo/try-catch';
import { resolveAdapter } from '~/adapters/registry';

export const fetchGiratudoStatusHandler: Handler<
  Params,
  Ports,
  Result
> = async (
  params,
  ports = {
    apiFetchGiratudoStatus: resolveAdapter('apiFetchGiratudoStatus'),
  },
) => {
  const [status, error] = await tryCatch(
    ports.apiFetchGiratudoStatus.handle(params.userId),
  );

  if (error) {
    console.error('Error fetching giratudo status:', error);

    return {
      raffleActive: false,
      alreadyParticipated: false,
      eligible: false,
      raffleEndTime: null,
      participationEnabled: false,
    };
  }

  return status as RaffleStatus;
};

type Params = { userId: number };

type Ports = { apiFetchGiratudoStatus: ApiFetchGiratudoStatusPort };

type Result = Promise<RaffleStatus>;
